import { createI18nText } from '@hilma/netina2all';

const sideBarText = createI18nText({
	he: {
		pd: 'פרטים אישיים',
		od: 'פרטי הזמנות',
		sd: 'פרטי תחנות חלוקה',
		sm: {
			sm: 'ניהול תחנה',
			o: 'הזמנות',
			sd: 'פרטי התחנה',
			fs: 'מכירה חופשית'
		},
		am: 'ניהול עמותה',
		lo: 'התנתק'
	},

	en: {
		pd: 'Personal details',
		od: 'Order details',
		sd: 'Distribution station details',
		sm: {
			sm: 'Station management',
			o: 'Orders',
			sd: 'Station details',
			fs: 'Free sale'
		},
		am: 'Association management',
		lo: 'Log out'
	}
});

export default sideBarText;